// extracted by mini-css-extract-plugin
export default {"selectionActions":"CampaignActions_selectionActions__JV2WA","dismiss":"CampaignActions_dismiss__XirhS"};